export default __webpack_public_path__ + "static/media/nodeorg.1b5a1a4a.png";